import styled from 'styled-components';

export default styled.div`
  gap: 12px;

  .loader-1 {
    color: #1570EF;
    height: 18px;
    width: 18px;
  }

  .loader-2 {
    color: #1570EF;
    height: 18px;
    width: 18px;
  }

  .wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    .tag {
      padding: 2px 4px;
      border: 1px solid #D0D5DD;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 500;
      color: #1F2A37;

      &.mineral {
        color: #52C41A;
        border-color: #B7EB8F;
        background: #F6FFED;
      }

      &.gold {
        color: #F5222D;
        border-color: #FFA39E;
        background: #FFF1F0;
      }

      &.tin, &.tantalum, &.tungsten, &.cobalt {
        color: #FA8C16;
        border-color: #FFD591;
        background: #FFF7E6;
      }
    }
  }

  .sections {
    display: flex;
    flex-direction: column;
    gap: var(--size);
    margin-top: 4px;

    .section {
      display: flex;
      gap: 12px;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      label {
        margin-bottom: 0px;
      }

      .label {
        flex: 1;
        
        label {
          font-size: 14px;
          font-weight: 600;
          color: #475467;
        }
      }

      .value label {
        font-size: 14px;
        font-weight: 600;
        color: #1D2939;
      }
    }
  }
`;
